module.exports = __webpack_public_path__ + "img/戴琼海.39262141.png";